import requestData from "./requestData";

class blogService {
    getItems = (take, skip) => requestData("GET", `/api/blogs${take || skip ? "?take=" + take + "&skip=" + skip : ""}`);
    getItem = (slug) => requestData("GET", `/api/blogs/${slug}`)
}

export default new blogService();